import { InstalledApplication } from '@era/locations-sdk';
import { createActionGroup, props } from '@ngrx/store';
import { ErrorModel } from '@era/app';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const InstalledApplicationsResolverActions = createActionGroup({
  source: 'Installed Applications Resolver',
  events: {
    'Installed Applications requested': props<{ brandId: string; locationId: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const InstalledApplicationsApiActions = createActionGroup({
  source: 'Installed Applications API',
  events: {
    'Installed Applications loaded': props<{ installedApplications: InstalledApplication[] }>(),
    'Installed Applications loaded error': props<{ error: ErrorModel }>(),
  },
});
